import { REST_API } from 'src/constants/DefaultValues';

export const isRagImageFile = (fileLike) => {
  const name = (fileLike?.name || fileLike?.file?.name || '').toLowerCase();
  const type = (fileLike?.type || fileLike?.file?.type || '').toLowerCase();
  return (
    /\.(jpe?g|png|webp)$/i.test(name) ||
    type === 'image/jpeg' ||
    type === 'image/png' ||
    type === 'image/webp'
  );
};

export const isRagDocumentFile = (fileLike) => {
  const name = (fileLike?.name || fileLike?.file?.name || '').toLowerCase();
  const type = (fileLike?.type || fileLike?.file?.type || '').toLowerCase();
  if (isRagImageFile(fileLike)) return true;
  if (type.startsWith('image/')) return false;
  if (type.startsWith('video/')) return false;
  return (
    /\.(pdf|docx?|txt|md|csv|xlsx?|pptx?|log)$/i.test(name) ||
    type.includes('pdf') ||
    type.includes('word') ||
    type.includes('spreadsheet') ||
    type.includes('excel') ||
    type.includes('powerpoint') ||
    type.includes('presentation') ||
    type.startsWith('text/')
  );
};

export const isVideoFile = (fileLike) => {
  const name = (fileLike?.name || fileLike?.file?.name || '').toLowerCase();
  const type = (fileLike?.type || fileLike?.file?.type || '').toLowerCase();
  return (
    /\.(mp4|mov|webm|mkv|avi)$/i.test(name) ||
    type === 'video/mp4' ||
    type === 'video/quicktime' ||
    type === 'video/webm' ||
    type === 'video/x-matroska' ||
    type === 'video/x-msvideo'
  );
};

export const isVideoUploadResult = (data) =>
  data?.upload_type === 'video' || Boolean(data?.video_id);

export const isBlueprintUploadResult = (data) =>
  data?.upload_type === 'blueprint' || Boolean(data?.blueprint_id);

export const mapUploadMetaToFile = (fileItem, meta) => {
  if (isBlueprintUploadResult(meta)) {
    const previewPath =
      meta.preview_image_url || `/ai/documents/blueprints/${meta.blueprint_id}/preview`;
    return {
      ...fileItem,
      uploading: false,
      uploaded: true,
      blueprintId: meta.blueprint_id,
      blueprintData: meta,
      previewUrl: previewPath.startsWith('http')
        ? previewPath
        : `${REST_API.replace(/\/$/, '')}${previewPath.startsWith('/') ? previewPath : `/${previewPath}`}`,
    };
  }
  if (isVideoUploadResult(meta)) {
    return {
      ...fileItem,
      uploading: false,
      uploaded: true,
      videoId: meta.video_id || meta.document_id,
      videoData: meta,
      documentId: meta.video_id || meta.document_id,
      chunksIndexed: meta.chunks_indexed,
    };
  }
  return {
    ...fileItem,
    uploading: false,
    uploaded: true,
    documentId: meta.document_id,
    chunksIndexed: meta.chunks_indexed,
  };
};

export const blueprintPreviewUrl = (data) => {
  if (!data?.blueprint_id) return null;
  const path =
    data.preview_image_url || `/ai/documents/blueprints/${data.blueprint_id}/preview`;
  if (path.startsWith('http')) return path;
  return `${REST_API.replace(/\/$/, '')}${path.startsWith('/') ? path : `/${path}`}`;
};
